import {appHeaderActionTypes} from "../actions/actionTypes";

const initialState = {
    prevRoute: '',
};

export const appHeaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case appHeaderActionTypes.SET_PREV_ROUTE:
            const prevRoute = action.payload;
            return {
                ...state,
                prevRoute: prevRoute,
            };
        case appHeaderActionTypes.RESET_APP_HEADER_DATA:
            return {...initialState}
        default:
            return state
    }
};